<script>
export default {
  name: 'SensorVirtualPeriodoNone',
  mounted() {
    this.$emit('change', {})
  },
}
</script>

<template>
  <div />
</template>

<style scoped lang="scss"></style>
